module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.typesAllowed.creditCard) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "radio-box category flex-center",
    class: {
      'active': _vm.type == 'CC'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "credit",
      "name": "radio",
      "value": "CC"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "CC")
    },
    on: {
      "change": function($event) {
        _vm.type = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label bold",
    attrs: {
      "for": "credit"
    }
  }, [_vm._v("\n          Cartão de Crédito\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.bankBill) ? _c('div', {
    class: _vm.colClassPayment
  }, [_c('div', {
    staticClass: "radio-box category",
    class: {
      'active': _vm.type == 'BC'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "billet",
      "name": "radio",
      "value": "BC"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "BC")
    },
    on: {
      "change": function($event) {
        _vm.type = "BC"
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.doc) ? _c('div', {
    class: _vm.colClassPayment
  }, [_c('div', {
    staticClass: "radio-box category",
    class: {
      'active': _vm.type == 'DO'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "doc",
      "name": "radio",
      "value": "DO"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "DO")
    },
    on: {
      "change": function($event) {
        _vm.type = "DO"
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.ted) ? _c('div', {
    class: _vm.colClassPayment
  }, [_c('div', {
    staticClass: "radio-box category",
    class: {
      'active': _vm.type == 'TE'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "ted",
      "name": "radio",
      "value": "TE"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "TE")
    },
    on: {
      "change": function($event) {
        _vm.type = "TE"
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.type == 'BC') ? _c('div', {
    staticClass: "margin-b20"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.type == 'DO') ? _c('div', {
    staticClass: "margin-b20"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.type == 'TE') ? _c('div', {
    staticClass: "margin-b20"
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.limiteCredito()) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-t20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Dados para Cartão de Crédito")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('credit-card', {
    ref: "creditCard",
    attrs: {
      "showCvv": true,
      "planId": _vm.planId,
      "addressStart": _vm.addressMailing
    },
    model: {
      value: (_vm.creditCard),
      callback: function($$v) {
        _vm.creditCard = $$v
      },
      expression: "creditCard"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'DC') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-t20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Dados para Débito em Conta")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('bank-account', {
    ref: "bankAccount",
    attrs: {
      "planId": _vm.planId
    },
    model: {
      value: (_vm.bankAccount),
      callback: function($$v) {
        _vm.bankAccount = $$v
      },
      expression: "bankAccount"
    }
  }), _vm._v(" "), _c('small', [_vm._v("Obs: A adesão é efetuada após a confirmação do pagamento. Para o débito em conta, o prazo para confirmação é de até 5 dias úteis.")])], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "radio-label bold",
    attrs: {
      "for": "billet"
    }
  }, [_c('i', {
    staticClass: "icon-bank-slip"
  }), _vm._v("\n        Boleto Bancário\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "radio-label bold",
    attrs: {
      "for": "doc"
    }
  }, [_c('i', {
    staticClass: "icon-doc"
  }), _vm._v("\n        DOC\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "radio-label bold",
    attrs: {
      "for": "ted"
    }
  }, [_c('i', {
    staticClass: "icon-ted"
  }), _vm._v("\n        TED\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de boletos bancários junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Documento de Ordem de Crédito (DOC) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Transferência Eletrônica Disponível (TED) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-693b2a93!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/payment/payment-options.vue
// module id = 2157
// module chunks = 1